export class StrongAuthenticationCreate {
  requestId: string;
}
